const CLOUDFRONT_HOST = process.env.NEXT_PUBLIC_DEPOP_CLOUDFRONT_HOST;

export const OUTFITS_UPSELL_CTA_ID = 'outfits_homepage_module';

export const OUTFIT_CARD_IMAGES = [
  `${CLOUDFRONT_HOST}/web/assets/homepage/outfit-card-1.webp`,
  `${CLOUDFRONT_HOST}/web/assets/homepage/outfit-card-2.webp`,
  `${CLOUDFRONT_HOST}/web/assets/homepage/outfit-card-3.webp`,
] as const;

export const DEPOP_D_LOGO = `${CLOUDFRONT_HOST}/web/assets/homepage/depop-pulse-icon.gif`;
